import { render } from "./cpt-input-option-base.vue?vue&type=template&id=0238b4c2"
import script from "./cpt-input-option-base.vue?vue&type=script&lang=js"
export * from "./cpt-input-option-base.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__